<template>
  <div ref="target" class="news-list">
    <div class="left">
      <div class="top">
        <div class="top-carousel">
          <NewsCarousel :bannerList="bannerList" />
          <SubmainList :domainList="domainList" />
        </div>
      </div>
      <div class="bottom">
        <NewsVideo :list="list" />
      </div>
    </div>
    <div class="middle">
      <PolicyNews :policyList="policyList" :domainList="domainList" />
    </div>
    <div class="right">
      <NoticeNews :noticeList="noticeList" :domainList="domainList" />
      <div class="notes">
        <NewsTests :testList="testList" />
      </div>
    </div>
  </div>
</template>

<script>
import NewsVideo from "../newsvideo/news-video";
import NewsTests from "../newstests/news-tests";
import NewsCarousel from "../common/new-carousel";
import SubmainList from "../common/submain-list.vue";
import PolicyNews from "../common/policy-news.vue";
import NoticeNews from "../common/notice-news.vue";
import {
  findNewsVideo,
  findGuiPeiNews,
  findNewsTests,
  findNewsBanner,
} from "@/api/news";
import {
  useLazyData,
  useLazyNews,
  useLazyNewsTests,
  useLazyNewsBanner,
} from "@/hooks/index";
import { computed, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    NewsVideo,
    NewsTests,
    NewsCarousel,
    SubmainList,
    PolicyNews,
    NoticeNews,
  },
  setup() {
    const store = useStore();
    const target = ref(null);
    const clID = ref(969);
    const { notice, policy } = useLazyNews(target, () =>
      findGuiPeiNews({ chID: 212 })
    );
    const { result } = useLazyData(target, () =>
      findNewsVideo({ clID: [clID.value] })
    );
    const { testList } = useLazyNewsTests(target, () =>
      findNewsTests({ clID: [clID.value] })
    );

    const { bannerList } = useLazyNewsBanner(target, () =>
      findNewsBanner({ clID: [clID.value] })
    );

    const domainList = computed(() => {
      let list = store.state.category.list.find(
        (items) => items.clID === clID.value
      );
      return list;
    });

    return {
      target,
      noticeList: notice,
      policyList: policy,
      testList,
      domainList,
      list: result,
      NewsVideo,
      bannerList,
    };
  },
};
</script>

<style lang="less" scoped>
.news-list {
  height: 500px;
  //background: #f0e5e5;
  display: flex;
  justify-content: space-between;
  .left {
    width: 400px;
    height: 500px;
    display: flex;
    flex-direction: column;
    .top {
      width: 400px;
      height: 240px;
      .top-carousel {
        display: inline-block;
        width: 360px;
        height: 130px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 15px;
        border-radius: 5px;
        .bottom-carousel {
          display: flex;
          flex-direction: column;
          margin-top: 10px;
          height: 80px;
          width: 360px;

          .carousel-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            width: 360px;
          }
          .carousel-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            width: 360px;
          }
        }
      }
    }

    .bottom {
      width: 400px;
      height: 250px;
    }
  }
  .middle {
    margin-top: 15px;
    width: 400px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
  }
  .right {
    margin-top: 15px;
    width: 400px;

    .notes {
    }
  }
}
</style>
